import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';

import { useGetTableLayout } from '../../../../hooks';
import { useSearch, useTranslate } from '../../../../../../hooks';

import { baseDateFormatting } from '../../../../../../helpers/utils';

import DefaultTableBodyCell from '../../../../../../components/table/DefaultTableBodyCell';
import { DateField, Table } from '../../../../../../components';
import ActionField from './components/ActionField';
import SearchSeaction from './components/SearchSeaction';
import LoaderCotainer from '../../../components/LoaderCotainer';
import { Modal, Tooltip, Typography } from '@mui/material';
import { useApp } from '../../../../../../context';
import _ from 'lodash';
import InfoCell from '../../../../../Dashboard/components/InfoCell';
import { useDeleteNoticePeriodAutomationConfig, useEditNoticePeriodAutomationConfig, useEditNoticePeriodAutomationStatus, useListNoticePeriodAutomationConfi, useNoticePeriodAutomationStatus } from './api';
import EditNoticePeriodAutomationConfig from './components/EditNoticePeriodAutomationConfig';

function NoticePeriodAutomationConf() {
  const [editModal, setEditModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [id, setId] = useState('')
  const [status, setStatus] = useState()
  const { companyId } = useApp()

  const leaveItems = [
    { id: 30, name: '30 Days' },
    { id: 0, name: 'Calendar Days' },
    { id: 365, name: 'Yearly' },
  ];

  const { translate } = useTranslate();
  const navigate = useNavigate();
  const [titleSearch, setTitleSearch] = useSearch('');
  const { layout } = useGetTableLayout({ type: 1 });
  const { noticePeriodAutomationConfigs, count, noticePeriodAutomationConfigsLoading, refetch } = useListNoticePeriodAutomationConfi({
    searchName: titleSearch
  })
  const { noticePeriodAutomationStatus, refetch: fetchAutomationStatus } = useNoticePeriodAutomationStatus({})

  const { editNoticePeriodAutomationConfig, isEditing } = useEditNoticePeriodAutomationConfig({
    id: id
  })
  const { editNoticePeriodAutomationStatus } = useEditNoticePeriodAutomationStatus({

  })

  const { deleteNoticePeriodAutomationConfig, isDeleting } = useDeleteNoticePeriodAutomationConfig({})
  //edit modal
  const toggleEditModal = () => {
    setEditModal((state) => !state);
  };

  const handleEditModal = (data) => {
    setModalData(() => data);
    toggleEditModal();
  };

  useEffect(() => {
    if (noticePeriodAutomationStatus) {
      setStatus(noticePeriodAutomationStatus?.notice_period_automation)
    }
  }, [noticePeriodAutomationStatus])

  const handleAutomationStatus = (data) => {
    editNoticePeriodAutomationStatus({ value: data })
      .then((res) => {
        fetchAutomationStatus()
      })
  }
  const onEditEmpType = (data) => {
    setId(data?.id)
    let payload = {
      name: data?.name,
      fnfDeduction: data?.fnfDeduction ? 1 : 0,
      days: data?.days,
      salaryWorkingDays: data?.salaryWorkingDays?.id,
    }
    editNoticePeriodAutomationConfig({ NoticePeriodAutomationConfig: payload }).then(() => {
      toggleEditModal();
      refetch();
    });
  };

  const onDelete = ({ data }) =>
    deleteNoticePeriodAutomationConfig(data?.id).then(() => refetch());

  //table columns config
  const columns = useMemo(
    () => [
      {
        name: 'typeId',
        label: translate('Type Id'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'name',
        label: translate('Type Name'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'noticePeriodDays',
        label: translate('Notice Period Days'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'fnfDeduction',
        label: translate('Fnf Deduction'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'salaryWorkingDays',
        label: translate('Salary Working Days'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'created_at',
        label: translate('Created At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'updated_at',
        label: translate('Updated At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'action',
        label: translate('Action'),
        options: {
          setCellHeaderProps: () => ({
            align: 'center',
            style: { fontWeight: '600' },
          }),
        },
      },
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  //formating table api resoponse data
  const tableData = useMemo(
    () => {
      const res = noticePeriodAutomationConfigs?.map((item) => {
        return {
          typeId: item?.id,
          name: item?.name,
          noticePeriodDays: item?.days,
          fnfDeduction: item?.fnf_deduction ? 'Yes' : 'No',
          salaryWorkingDays: leaveItems?.find((wrk) => wrk?.id == item?.notice_period_salary_working_days)?.name,
          createdBy: item?.created_by,
          created_at: item?.created_at,
          updated_at: item?.updated_at,
          action: (
            <ActionField
              onEdit={() => {
                handleEditModal(item);
              }}
              onReject={() => onDelete({ data: item })}
              isRejecting={isDeleting}
              className="justify-center"
              newCancelLayout={true}
            />
          ),
        };
      });

      return res;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // [data, isDeleting],
  );

  const onCreate = () => {
    navigate('create', {
      state: { compEmpTypeList: "data" },
    });
  };

  return (
    <div>
      <SearchSeaction
        handleSearchTitle={setTitleSearch}
        openAddDesignation={onCreate}
        status={status}
        disable={tableData?.length >= 1 ? true : false}
        handleAutomationStatus={handleAutomationStatus}
      />
      {noticePeriodAutomationConfigsLoading ? (
        <LoaderCotainer />
      ) : (
        <div className="mt-4">
          <Table
            columns={columns}
            data={tableData || []}
            count={count}
            options={{ ...layout }}
          />
        </div>
      )}

      <Modal open={editModal} onClose={toggleEditModal}>
        <EditNoticePeriodAutomationConfig
          toggleModal={toggleEditModal}
          customHandler={onEditEmpType}
          seletedData={modalData}
          isEditing={isEditing}
        />
      </Modal>
    </div>
  );
}

export default NoticePeriodAutomationConf;
